/* loaded by smart-asset */
export default require("./assets/full-tier.i.svg")